// Copyright (c) 2017 Deere & Company

import Criteria, {getDefaultState as getDefaultCriteriaState} from '../state/criteria';
import actions from '../actions-list';

const resetCriteria = state =>
    Criteria.update(state, {
        $set: getDefaultCriteriaState()
    });

const updateClaimCreatedDate = (state, action) =>
    Criteria.update(state, {
        claimCreated: {
            from: {
                $set: action.dates.from
            },
            to: {
                $set: action.dates.to
            }
        }
    });

const updateCriterion = (state, action) =>
    Criteria.update(state, {
        [action.property]: {
            $set: action.value
        }
    });

export default (state = getDefaultCriteriaState(), action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_CRITERIA]: resetCriteria,
        [actions.UPDATE_ADVANCED_CLAIM_SUMMARY_CLAIM_CREATED_DATE]: updateClaimCreatedDate,
        [actions.UPDATE_ADVANCED_CLAIM_SUMMARY_CRITERION]: updateCriterion
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/criteria.js